<div class="t-bullet-chart-tooltip-description">
  <ng-content></ng-content>
</div>
